export default [
    {
        path: '/:cid/library',
        name: 'Enterprise Asset Library',
        component: () => import(/* webpackChunkName: "enterprise-asset-library" */ '@/views/AssetLibrary/AssetLibrary.vue'),
        meta: {title: '资产中心', requiresAuth: true}
    },
    {
        path: '/review/:companyId/:reviewId',
        name: 'External Review',
        component: () => import(/* webpackChunkName: "external-review" */ '@/views/ExternalReview/ExternalReview.vue'),
        meta: {title: '外部审阅', requiresAuth: false, allowAuthenticated: true, hideHeader: true, preventAdvanceSearch: true}
    },
    {
        path: '/:cid/creative',
        name: 'Legacy Creative Redirect',
        redirect: (to) => ({name: 'Projects', params: {cid: to.params.cid}}),
        meta: {title: 'Projects', requiresAuth: true, legacy: true}
    }
];
